/**
 * Handle accordion behavior on WOOT Sell Pages (currently only in registration block)
 */
$(function () {
	// select all accordion cards. note there can only be one accordion section on the page
	var $accordion_cards = $(".accordion-card");
	// when any header is clicked,
	// 		toggle that card
	$accordion_cards.children(".accordion-header").on("click", function (_e) {
		var $this_card = $(this).parent();
		// if this one was open, close it and return
		if (!$this_card.hasClass("closed")) {
			$this_card.addClass("closed"); // closed class for styling
			$this_card.children(".content").slideUp(200); // jquery animation for sliding effect
			$(this).attr("aria-expanded", "false"); // aria-expanded attribute on header for screen readers
			setTimeout(function () {
				$("#side-column").trigger("resize");
			}, 200);
			return;
		}
		// else, open it and return
		$this_card.removeClass("closed");
		$this_card.children(".content").slideDown(200);
		$(this).attr("aria-expanded", "true");
		setTimeout(function () {
			$("#side-column").trigger("resize");
		}, 200);
	});

	// INITIAL STATE
	// close all that have the close-on-initial-load class
	var $cards_to_close_initially = $(".accordion-card.close-on-initial-load");
	$cards_to_close_initially.each(function (i, ele) {
		$(ele).addClass("closed"); // class for styling
		$(ele).children(".content").slideUp(0); // close without slide animation
		$(ele).children(".accordion-header").attr("aria-expanded", "false"); // set aria-expanded to false for screen readers
	});
	setTimeout(function () {
		$("#side-column").trigger("resize");
	}, 10);
});
